import { render, staticRenderFns } from "./OneProjectPage.vue?vue&type=template&id=2a4b3a18&scoped=true"
import script from "./OneProjectPage.vue?vue&type=script&lang=js"
export * from "./OneProjectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b3a18",
  null
  
)

export default component.exports